define 'controller/StayConnectedController', ['jquery', 'lib/kryptonite', 'lib/formdata'], ($) ->
  class StayConnectedController

    constructor: (@$el) ->
#      @_onLoginStayConnectedInfo()
#      @_onRegistrationStayConnectedInfo()
#      @_onLoginStayConnectedInfoText()
#      @_onRegistrationStayConnectedInfoText()
      @_onLoginStayConnectedInfoIconClick()
      @_onRegistrationStayConnectedInfoIconClick()

      # for frontend-tests
      @$el.attr('data-initialized', true);

    _onLoginStayConnectedInfoIconClick: ->
      $('.login__stay-connected__checkbox-container__info-button').off()
      $('.login__stay-connected__checkbox-container__info-button').on 'click', (e) ->
        e.preventDefault()
        $('.stay-connected-text-container').toggleClass('inactive')

    _onRegistrationStayConnectedInfoIconClick: ->
      $('.registration__stay-connected__checkbox-container__info-button').off()
      $('.registration__stay-connected__checkbox-container__info-button').on 'click', (e) ->
        e.preventDefault()
        $('.stay-connected-text-container').toggleClass('inactive')